import axios from 'axios';
import ApiConfig from './config/ApiConfig';
import { clearStorage, getObjectFromStore, storageKeys } from './storage/Storage';
import { toast } from 'react-toastify';

axios.interceptors.request.use((request) => requestHandler(request));

axios.interceptors.response.use(
  (response) => {
    checkTokenIsValid(response);
    return response;
  },
  (error) => errorHandler(error),
);

const checkTokenIsValid = (response) => {
  if (response?.data?.status == 401) {
    window.location = '/login';
    clearStorage()
    toast.error(response.data.message, {
      autoClose: 2500,
    });
  }
};

const requestHandler = async (request) => {
  let token = ApiConfig.token;
  if (!token) {
    token = await getObjectFromStore(storageKeys.token);
  }
  request.headers = {
    Authorization: `${token}`,
    // 'X-CSCAPI-KEY': "RmtmRFFKZDg3Y0cyaTVMWlNpNHVYcjV2VWZ3OWZGWU9nRHlpYkJuNQ==",
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...request.headers
  };
 
  return request;
};

const errorHandler = async (error) => {
  console.log('errorHandler', error.response);
  throw error.response;
};
